"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  isChrome: () => isChrome,
  isClient: () => isClient,
  isRSC: () => isRSC,
  isServer: () => isServer,
  isTouchable: () => isTouchable,
  isWeb: () => isWeb,
  isWebTouchable: () => isWebTouchable,
  isWindowDefined: () => isWindowDefined,
  useIsomorphicLayoutEffect: () => useIsomorphicLayoutEffect
});
module.exports = __toCommonJS(src_exports);
var import_react = require("react");
const import_meta = {};
const isWeb = process.env.TAMAGUI_TARGET === "web";
const isWindowDefined = typeof window !== "undefined";
const isServer = isWeb && !isWindowDefined;
const isClient = isWeb && isWindowDefined;
const isRSC = process.env.ENABLE_RSC ? (
  // note this is statically analyzed so no funny business, just access it without optional chaining
  // @ts-ignore
  import_meta.env ? (
    // @ts-ignore
    import_meta.env.SSR
  ) : false
) : false;
const idFn = () => {
};
const useIsomorphicLayoutEffect = isRSC ? idFn : isServer ? import_react.useEffect : import_react.useLayoutEffect;
const isChrome = typeof navigator !== "undefined" && /Chrome/.test(navigator.userAgent || "");
const isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
const isTouchable = !isWeb || isWebTouchable;
if (process.env.NODE_ENV === "development") {
  if (!process.env.TAMAGUI_TARGET) {
    console.warn(`Must set TAMAGUI_TARGET to "web" or "native"`);
  } else if (isClient && process.env.TAMAGUI_TARGET !== "web" && process.env.TAMAGUI_IGNORE_TARGET !== "1") {
    console.warn(
      `Must set TAMAGUI_TARGET to "web" for web apps - if you have window defined outside of the browser, set TAMAGUI_IGNORE_TARGET=1 to hide this`
    );
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isChrome,
  isClient,
  isRSC,
  isServer,
  isTouchable,
  isWeb,
  isWebTouchable,
  isWindowDefined,
  useIsomorphicLayoutEffect
});
//# sourceMappingURL=index.js.map
